export const CHART_PROVIDER_INVALID_ERROR = 'Invalid Provider.'
export const CHART_PROVIDER_REQUIRED_ERROR = 'Provider name is required'
export const CHART_TITLE_REQUIRED_ERROR = 'Chart name is required'
export const CHART_PATIENT_REQUIRED_ERROR = 'Patient name is required'
export const CHART_DENTAL_CONTENT_REQUIRED_ERROR =
  'At least one condition is required'
export const CHART_PERIO_CONTENT_REQUIRED_ERROR =
  'At least one measurement is required'

export function isChartProviderHardError(message?: string): boolean {
  return (
    message === CHART_PROVIDER_INVALID_ERROR ||
    message === CHART_PROVIDER_REQUIRED_ERROR
  )
}

/** True when save validation failed on Charting information fields (not content). */
export function hasChartingInformationFieldErrors(errors: {
  [key: string]: string
}): boolean {
  return !!(errors.patient_id || errors.provider_id || errors.title)
}

function formatRequiredFieldsMessage(fieldLabels: string[]): string {
  if (fieldLabels.length === 0) {
    return ''
  }
  if (fieldLabels.length === 1) {
    return `${fieldLabels[0]} is required`
  }
  if (fieldLabels.length === 2) {
    return `${fieldLabels[0]} and ${fieldLabels[1]} are required`
  }
  const leading = fieldLabels.slice(0, -1).join(', ')
  return `${leading}, and ${fieldLabels[fieldLabels.length - 1]} are required`
}

/** Build a single snackbar message from manual-save field errors. */
export function buildManualSaveValidationToastMessage(errors: {
  [key: string]: string
}): string {
  const requiredFieldLabels: string[] = []
  const otherMessages: string[] = []
  if (errors.provider_id === CHART_PROVIDER_REQUIRED_ERROR) {
    requiredFieldLabels.push('Provider name')
  } else if (errors.provider_id) {
    otherMessages.push(errors.provider_id)
  }
  if (errors.title === CHART_TITLE_REQUIRED_ERROR) {
    requiredFieldLabels.push('Chart name')
  } else if (errors.title) {
    otherMessages.push(errors.title)
  }
  if (errors.patient_id === CHART_PATIENT_REQUIRED_ERROR) {
    requiredFieldLabels.push('Patient name')
  } else if (errors.patient_id) {
    otherMessages.push(errors.patient_id)
  }
  if (errors.content) {
    otherMessages.push(errors.content)
  }
  const requiredMessage = formatRequiredFieldsMessage(requiredFieldLabels)
  return [requiredMessage, ...otherMessages].filter(Boolean).join('. ')
}
